import RatingEstimatesRealResultsListStates, { RatingEstimatesRealResultsListProps } from "./RatingEstimatesRealResultsList.models";
import React from "react"
import './RatingEstimatesRealResultsList.scss';
import realResutlsAvatar from '../../../assest/images/card-image/realResutlsAvatar.png'
import RatingEstimatesRealResultViewModal from '../rating-estimates-real-result-view-modal/RatingEstimatesRealResultViewModal'

export default class RatingEstimatesRealResultsList extends React.PureComponent<RatingEstimatesRealResultsListProps, RatingEstimatesRealResultsListStates>{

    constructor(props: any) {
        super(props);
        this.state = { data: [], openModal: false }
    }

    componentDidMount = () => {
        this.setState({
            data: []
        })
    }

    openResultViewModal(id?: string) {
        this.setState({
            openModal: true,
            rowId: id
        })
    }

    render(): React.ReactNode {
        let { datas } = this.props
        return <>
            <div className="dropdown-list rating-estimates-real-results-list-area" >
                <div className="col-12">
                    {datas.map((result, key) => {
                        return (
                            <div key={key} className="tk-card">
                                <div className="card-icon">
                                    <img src={realResutlsAvatar} alt="personal content menu" />
                                </div>
                                <div className="title">
                                    <label>قبولی</label>
                                </div>
                                <div className="col-12 user-info">
                                    <div className="tk-inline">
                                        <div className="col-6 notspace">
                                            <label>گروه:</label>
                                        </div>
                                        <div className="col-6 notspace info">
                                            <label>{result.group}</label>
                                        </div>
                                    </div>
                                    <div className="tk-inline">
                                        <div className="col-6 notspace">
                                            <label>رتبه‌ی کشوری:</label>
                                        </div>
                                        <div className="col-6 notspace info">
                                            <label>{result.countryRank}</label>
                                        </div>
                                    </div>
                                    <div className="tk-inline">
                                        <div className="col-6 notspace">
                                            <label>رتبه در سهمیه:</label>
                                        </div>
                                        <div className="col-6 notspace info">
                                            <label>{result.quotaRank}</label>
                                        </div>
                                    </div>
                                    <div className="tk-inline">
                                        <div className="col-6 notspace">
                                            <label>سهمیه در منطقه:</label>
                                        </div>
                                        <div className="col-6 notspace info">
                                            <label>{result.regionRank}</label>
                                        </div>
                                    </div>
                                    <div className="tk-inline">
                                        <div className="col-6 notspace">
                                            <label>جنسیت:</label>
                                        </div>
                                        <div className="col-6 notspace info">
                                            <label>{result.gender}</label>
                                        </div>
                                    </div>
                                    <div className="tk-inline">
                                        <div className="col-6 notspace">
                                            <label>شهر:</label>
                                        </div>
                                        <div className="col-6 notspace info">
                                            <label>{result.city}</label>
                                        </div>
                                    </div>
                                    <div className="tk-inline">
                                        <div className="col-6 notspace">
                                            <label>رشته‌ی قبولی:</label>
                                        </div>
                                        <div className="col-6 notspace info">
                                            <label>{result.fields}</label>
                                        </div>
                                    </div>
                                    <div className="tk-inline">
                                        <div className="col-12 notspace mb-2 mt-2">
                                            <button className="btn btn-primary full-width" onClick={() => this.openResultViewModal(result.id)}>مشاهده ی‌ کارنامه</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <RatingEstimatesRealResultViewModal id={this.state.rowId} showModal={this.state.openModal} closeModal={() => this.setState({ openModal: false, rowId: undefined })} />
        </>
    }
}